import React from 'react';
import styles from './Audio.module.scss';
import Actions from '../actions/Actions';
import ContentAudio from '../../../../components/content-audio/ContentAudio';

type Props = {
  data: string;
  isFullScreen: boolean;
  isPreview?: boolean;
  goBack?: () => void;
};

function Audio(props: Props) {
  const { data, isFullScreen, isPreview, goBack } = props;

  return (
    <Actions fullScreen={isFullScreen} isPreview={isPreview} goBack={goBack}>
      <div className={styles.content}>
        <ContentAudio data={data}/>
      </div>
    </Actions>
  );
}

export default Audio;
